/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {Button, Grid, Paper, TextField, ThemeProvider} from "@mui/material";
import {SEText} from "../../../../components/SEText";
import {Controller, useForm} from "react-hook-form";
import {TiposRegistroInterface} from "../../../../interfaces";
import {TiposRegistroService} from "../services";
import useRenderFormStore from "../../stores/useRenderFormStore";
import {removeEmpty} from "../../../../../utils/utils";
import {BaSeDialogContext} from "@base/react";
import useFormMutation from "../../hooks/useFormMutation";
import theme from "../../../../mui-theme";
import {useHistory} from "react-router-dom";
import {useLocation, useParams} from "react-router";
import {TextFieldCounter} from "../../../../components/TextFieldCounter";
import {SEFormUserAction} from "../../../../components/SEFormUserAction";

const Formulario = () => {

    const {showModal} = React.useContext(BaSeDialogContext);
    const history = useHistory();
    const location = useLocation();
    const { id } = useParams<{ id: string }>();
    const hasCopyParam = location.pathname.includes('/copy');

    const { formData: editFormData, setFormData: setEditFormData, handleShowForm } = useRenderFormStore();

    const [formData, setFormData] = useState<TiposRegistroInterface>(editFormData?.id ? editFormData : {
        nome: '',
        tipo: '',
        descricao: '',
        acaoRegistro: '',
        regrasServico: '',
    });

    const {control, handleSubmit, reset} = useForm<TiposRegistroInterface>({
        defaultValues: formData,
    });
    const onResetFields = () => {
        reset({
            nome: '',
            tipo: '',
            descricao: '',
            acaoRegistro: '',
            regrasServico: '',
        });
    };

    const goBack = () => {
         handleShowForm(false);
         history.push(`/tabelas-de-controle/tipos-registros`);
    };

    useEffect(() => {
        const fetchDataIfNecessary = async () => {
            if(id) {
                if (!editFormData) {
                    const data = await TiposRegistroService.read(id);
                    setEditFormData(data);
                    reset(data)
                } else {
                    setFormData(editFormData)
                }
            }
        };

        fetchDataIfNecessary();
    }, [id, editFormData, setFormData]);

    const {
        createMutation,
        updateMutation,
    } = useFormMutation({
        showModal,
        service: TiposRegistroService,
        onCloseModalSuccess: () => {
            onResetFields();
            goBack()
        },
        onCloseModalUpdate: () => goBack(),
        onCloseModalError: () => {
        },
    });

    const submitForm = async (dataForm: TiposRegistroInterface) => {

        if (hasCopyParam) {
            delete dataForm.id;
            delete dataForm.status;
        }

        const cleanedData = removeEmpty(dataForm);
        console.log('Dados limpos:', cleanedData);

        if (dataForm.id) {
            await updateMutation(cleanedData).then();
        } else {
            await createMutation(cleanedData).then();
        }
    };

    return (
        <Paper
            sx={{
                display: "flex",
                alignItems: "center",
                padding: 2,
            }}
        >
            <ThemeProvider theme={theme}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SEText
                        as="h2"
                        size={"medium"}
                        font="Mulish"
                        weight="bold"
                        color="#7B80FF"
                    >
                        {editFormData?.id ? (hasCopyParam ? 'Copiar' : 'Editar') : 'Incluir'}
                    </SEText>
                </Grid>

                <Grid container item spacing={3}>

                    <Grid item md={4}>
                        <Controller
                            control={control}
                            name="tipo"
                            rules={{required: "Este campo é obrigatório"}}
                            render={({field: {value, onChange}, fieldState: {error}}) => (
                                <>
                                    <TextField
                                        id="tipo"
                                        label="Tipo de registro *"
                                        placeholder="Digite o tipo de registro"
                                        fullWidth
                                        value={value || ""}
                                        onChange={onChange}
                                        inputProps={{ maxLength: 255 }}
                                    />
                                    <TextFieldCounter value={value} maxLength={255}/>
                                    {error && (
                                        <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                    )}
                                </>
                            )}
                        />
                    </Grid>

                    <Grid item md={4}>
                        <Controller
                            control={control}
                            name="descricao"
                            rules={{required: "Este campo é obrigatório"}}
                            render={({field: {value, onChange}, fieldState: {error}}) => (
                                <>
                                    <TextField
                                        id="descricao"
                                        label="Texto do registro *"
                                        placeholder="Digite o texto que aparecerá na descrição do registro"
                                        fullWidth
                                        value={value || ""}
                                        onChange={onChange}
                                        inputProps={{ maxLength: 255 }}
                                    />
                                    <TextFieldCounter value={value} maxLength={255}/>
                                    {error && (
                                        <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                    )}
                                </>
                            )}
                        />
                    </Grid>

                    <Grid item md={4}>
                        <Controller
                            control={control}
                            name="nome"
                            rules={{required: "Este campo é obrigatório"}}
                            render={({field: {value, onChange}, fieldState: {error}}) => (
                                <>
                                    <TextField
                                        id="nome"
                                        label="Sobre o registro *"
                                        placeholder="Digite informações sobre o registro"
                                        fullWidth
                                        value={value || ""}
                                        onChange={onChange}
                                        inputProps={{ maxLength: 255 }}
                                    />
                                    <TextFieldCounter value={value} maxLength={255}/>
                                    {error && (
                                        <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                    )}
                                </>
                            )}
                        />
                    </Grid>
                </Grid>

                <Grid item md={12}>
                    <Controller
                        name="regrasServico"
                        control={control}
                        rules={{required: "Este campo é obrigatório"}}
                        render={({field, fieldState: {error}}) => (
                            <>
                                <TextField
                                    id="regrasServico"
                                    label="Regras específicas do registro  *"
                                    placeholder="Digite aqui as regras para a realização do registro"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    onChange={field.onChange}
                                    value={field.value}
                                    inputProps={{ maxLength: 400 }}
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            height: "100%",
                                        },
                                    }}
                                />
                                <TextFieldCounter value={field.value} maxLength={400}/>
                                {error && (
                                    <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                )}
                            </>
                        )}
                    />
                </Grid>

                <Grid item md={12}>
                    <Controller
                        name="acaoRegistro"
                        control={control}
                        rules={{required: "Este campo é obrigatório"}}
                        render={({field, fieldState: {error}}) => (
                            <>
                                <TextField
                                    id="acaoRegistro"
                                    label="Ação do registro *"
                                    placeholder="Digite a ação do registro"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    onChange={field.onChange}
                                    value={field.value}
                                    inputProps={{ maxLength: 400 }}
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            height: "100%",
                                        },
                                    }}
                                />
                                <TextFieldCounter value={field.value} maxLength={400}/>
                                {error && (
                                    <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                )}
                            </>
                        )}
                    />
                </Grid>


                <Grid item md={12} display="flex" justifyContent="flex-end" gap={2}>
                    <Button variant="outlined" onClick={goBack}>
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit(submitForm)}
                        disabled={false}
                    >
                        {editFormData?.id ? (hasCopyParam ? 'Incluir' : 'Editar') : 'Incluir'}
                    </Button>
                </Grid>

                <Grid item md={12} >
                    <SEFormUserAction data={editFormData}/>
                </Grid>
            </Grid>
            </ThemeProvider>
        </Paper>
    );
};

export default Formulario;
